import { render } from "./OrderDetailsPage.vue?vue&type=template&id=15d21ef8&scoped=true"
import script from "./OrderDetailsPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailsPage.vue?vue&type=script&lang=js"

import "./OrderDetailsPage.vue?vue&type=style&index=0&id=15d21ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d21ef8"]])

export default __exports__